import React from 'react';
export function HeroSection() {
  return <div className="bg-brand-dark text-white py-16" data-id="element-292">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-293">
        <h1 className="text-4xl font-bold mb-4" data-id="element-294">Contact Us</h1>
        <p className="text-xl text-gray-300" data-id="element-295">
          Get in touch with our sales and support team.
        </p>
      </div>
    </div>;
}